import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLandingPageAsset,
  BackendMutationCreateLandingPageAssetFromDraftArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_ASSET } from './schema';

const MUTATION = gql`
  mutation CreateCOAssetFromDraft(
    $projectId: ID!
    $draftAssetId: ID!
    $continuousOptimizationSegmentId: ID!
  ) {
    createLandingPageAssetFromDraft(
      projectId: $projectId
      draftAssetId: $draftAssetId
      continuousOptimizationSegmentId: $continuousOptimizationSegmentId
    ) {
      ...LandingPageAsset
    }
  }
  ${FRAGMENT_CO_ASSET}
`;

type Variables = BackendMutationCreateLandingPageAssetFromDraftArgs;
type Result = BackendLandingPageAsset;

export const createCOAssetFromDraft = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
